export default __webpack_public_path__ + "static/media/HARYANA-7.ac125f8a.webp";